import { Card, CardContent } from '@sitewise/ui';
import { useEffect, useState } from 'react';

import type { UpsertUnitLeadStatusInput } from '@sitewise/shared';


interface Props {
  notes: string | null;
  disabled?: boolean;
  onSave: (patch: UpsertUnitLeadStatusInput) => Promise<void>;
}

/** Free-form notes that don't fit the structured "work done" log.
 *  Inline editable; auto-saves on blur. We treat undefined ↔ null
 *  as equivalent for the empty case so toggling focus on an empty
 *  field doesn't churn the API. */
export function NotesField({ notes, disabled, onSave }: Props) {
  const [draft, setDraft] = useState<string>(notes ?? '');

  useEffect(() => {
    setDraft(notes ?? '');
  }, [notes]);

  async function handleBlur() {
    const next = draft.trim();
    const normalisedCurrent = (notes ?? '').trim();
    if (next === normalisedCurrent) return;
    await onSave({ notes: next === '' ? null : next });
  }

  return (
    <Card>
      <CardContent className="space-y-2 p-5">
        <div>
          <h3 className="text-sm font-semibold">Notes</h3>
          <p className="text-xs text-fg-muted">
            Catch-all notes that don't belong in the work log. Saved on blur.
          </p>
        </div>
        <textarea
          value={draft}
          onChange={(e) => setDraft(e.target.value)}
          onBlur={handleBlur}
          rows={4}
          disabled={disabled}
          placeholder="Any context worth keeping with this unit's lead status."
          className="w-full rounded-md border border-border bg-surface px-3 py-2 text-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary"
        />
      </CardContent>
    </Card>
  );
}
